import { ReactNode, useEffect, useState } from 'react';
import { CarouselProps } from 'nuka-carousel';

import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { CustomSwiper } from './styled';

enum EMediaWidth {
    desktop = '(min-width: 1600px)',
    sDesktop = '(max-width: 1599px) and (min-width: 1280px)',
    laptop = '(max-width: 1279px) and (min-width: 768px)',
    mobile = '(max-width: 767px)',
}

type TBreakpoint = 'desktop' | 'sDesktop' | 'laptop' | 'mobile';

type TVisibleSlides = {
    [key in TBreakpoint]: number;
};

interface IProps extends CarouselProps {
    children: Array<ReactNode>,
    desktopSlideWidth?: string,
    mobileSlideWidth?: string,
    visibleSlides?: TVisibleSlides,
    [key: string]: unknown,
}

const defaultVisibleSlides: TVisibleSlides = {
    desktop: 4,
    sDesktop: 3,
    laptop: 2,
    mobile: 1,
};

/**
 * Адаптив карусели Nuka-Carousel
 * @param items - массив компонентов (TariffCard, ProductCard, etc)
 * @param desktopSlideWidth - ширина слайда карусели на десктопе
 * @param mobileSlideWidth - ширина слайда карусели на мобилках
 * @param visibleSlides - количество целых видимых слайдов в карусели
 * @returns Function{}
 */
// todo: move to ui-react
const AdaptiveNukaCarousel = ({
    children,
    desktopSlideWidth = '304px',
    mobileSlideWidth = '288px',
    visibleSlides = defaultVisibleSlides,
    ...props
}: IProps): JSX.Element => {
    const [hideArrows, setHideArrows] = useState(false);
    const [hideDots, setHideDots] = useState(false);
    const [slideWidth, setSlideWidth] = useState(desktopSlideWidth);

    const isDesktop = useMatchMedia(EMediaWidth.desktop);
    const isSDesktop = useMatchMedia(EMediaWidth.sDesktop);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);
    const isMobile = useMatchMedia(EMediaWidth.mobile);

    useEffect(() => {
        if (isMobile) {
            setSlideWidth(mobileSlideWidth);
            setHideArrows(true);
            if (children.length > visibleSlides.mobile) {
                setHideDots(false);
            } else {
                setHideDots(true);
            }
        } else {
            setSlideWidth(desktopSlideWidth);
            if ((isLaptop && children.length > visibleSlides.laptop) ||
                (isSDesktop && children.length > visibleSlides.sDesktop) ||
                (isDesktop && children.length > visibleSlides.desktop)) {
                setHideArrows(false);
                setHideDots(false);
            } else {
                setHideArrows(true);
                setHideDots(true);
            }
        }
    }, [
        isDesktop,
        isSDesktop,
        isLaptop,
        isMobile,
        children,
        desktopSlideWidth,
        mobileSlideWidth,
        visibleSlides,
    ]);

    return (
        <CustomSwiper
            withoutArrows={hideArrows}
            withoutDots={hideDots}
            slideWidth={slideWidth}
            {...props}
        >
            {children}
        </CustomSwiper>
    );
};

export default AdaptiveNukaCarousel;
